import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const BoxContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ theme, isCard }) => ({
  border: isCard ? 'none' : `1px solid  ${theme.palette.colors.borderLine}`,
  borderRadius: '5px',
  backgroundColor: isCard
    ? 'transparent'
    : theme.palette.colors.secondaryBackground,
  width: '100%',
}));

export const MainInfoContainerStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ theme, isCard }) => ({
  height: isCard && '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '16px',
  padding: isCard ? '12px 12px 12px 20px' : '8px 16px',
  [theme.breakpoints.down('lg')]: {
    padding: '8px',
  },
}));

export const LeftContainerStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    width: 'auto',
  },
}));

export const BottomContainerStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
}));

export const LabelHeaderStyled = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 'bold',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textTransform: 'Uppercase',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '214px',
  [theme.breakpoints.down('lg')]: {
    maxWidth: '288px',
  },
}));

export const LabelStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ theme, isCard }) => ({
  fontWeight: isCard ? 'bold' : 500,
  color: theme.palette.colors.label,
  textTransform: 'Uppercase',
  fontSize: '8px',
}));

export const LabelValueStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCard' && prop !== 'small',
})(({ theme, isCard, small }) => ({
  fontSize: isCard && small ? '10px' : '12px',
  fontWeight: isCard && !small ? 'bold' : 500,
  lineHeight: 1.5,
  letterSpacing: '-0.17px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const BoxInlineContentStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hide',
})(({ theme, hide }) => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '214px',
  '&:nth-child(2)': {
    [theme.breakpoints.down('lg')]: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '288px',
    },
  },
  '&#variableValuesContainer': {
    display: hide && 'none',
  },

  [theme.breakpoints.down('lg')]: {
    maxWidth: '288px',
  },
}));

export const MainDetailsStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'noBorder',
})(({ theme, noBorder }) => ({
  fontSize: '12px',
  fontWeight: 'bold',
  lineHeight: 1.5,
  letterSpacing: '0.33px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  textTransform: 'Uppercase',
  paddingRight: '6px',
  marginRight: '6px',
  borderRight: noBorder
    ? 0
    : `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
}));

export const QuotationStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ theme, isCard }) => ({
  fontSize: isCard ? '18px' : '24px',
  fontWeight: 'bold',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  marginTop: '8px',
}));

export const BoxTimeStyled = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ theme, isCard }) => ({
  fontSize: '10px',
  fontWeight: isCard ? 500 : 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  lineHeight: 1.8,
  letterSpacing: '0.28px',
  marginBottom: '4px',
}));

export const BoxScheduleStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
  padding: '6px 16px',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontSize: '12px',
  fontWeight: 500,
}));

export const LeftInfoWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ isCard }) => ({
  marginRight: isCard ? '16px' : '24px',
}));

export const ContainerLeft = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCard',
})(({ isCard }) => ({
  width: isCard && '45%',
}));

export const FavoriteIcon = styled(FontAwesomeIcon)(({ theme, disabled }) => ({
  color: disabled ? theme.palette.colors.lower : theme.palette.colors.star,
  fontSize: '16px',
  marginRight: '8px',
}));
